import type AsyncStatus from 'mini-common-schema/lib/schema/AsyncStatus';
import type { ActivityPaneStore } from './schema/ActivityPaneStore';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import type { ReactionActivityFeedItem } from './schema/ActivityFeedItem';

const initialActivityPaneStore: ActivityPaneStore = {
    isActivityPaneOpen: false,
    notificationsLoadingStatus: 0,
    areNewNotificationsPresent: false,
    items: new ObservableMap<string, ReactionActivityFeedItem>(),
    whatsNewItems: [],
    whatsNewLoadingStatus: 0,
};

export const getStore = createStore<ActivityPaneStore>(
    'ActivityPaneStore',
    initialActivityPaneStore
);

export const activityPaneStore = getStore();
